import { render, staticRenderFns } from "./FragmentLabelHistory.vue?vue&type=template&id=4f6ce946&scoped=true"
import script from "./FragmentLabelHistory.vue?vue&type=script&lang=ts"
export * from "./FragmentLabelHistory.vue?vue&type=script&lang=ts"
import style0 from "./FragmentLabelHistory.vue?vue&type=style&index=0&id=4f6ce946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6ce946",
  null
  
)

export default component.exports